import { useState, useEffect, useCallback } from 'react';
import useFirestore from './useFirestore';

function useUser() {
  const firestore = useFirestore();
  const [user, setUser] = useState();

  useEffect(() => {
    const fn = async () => {
      if (!localStorage.getItem('user')) return;

      const { uid } = JSON.parse(localStorage.getItem('user') || '{}');
      const userRef = await firestore.collection('users').doc(uid).get();
      let userData = userRef.data();
      userData = { ...userData };
      setUser({ id: uid, ...userData });
    };

    fn();
  }, [firestore]);

  const updateUser = useCallback(
    async (userData) => {
      delete userData.groupName;
      try {
        await firestore
          .collection('users')
          .doc(userData.id)
          .update({ ...userData });
        return true;
      } catch (e) {
        console.log('profile update err:', e);
        return false;
      }
    },
    [firestore],
  );

  return [user, updateUser];
}

export default useUser;
